<template>
  <rect width="12" height="12" rx="6" />
  <path
    d="M2.77125 6.18952C2.69582 6.27553 2.65911 6.38503 2.66807 6.4982C2.67703 6.61138 2.73021 6.71437 2.81836 6.78793L4.95794 8.58345C5.03742 8.64994 5.13597 8.68559 5.23944 8.68559C5.25216 8.68559 5.26516 8.68502 5.27817 8.68389C5.39522 8.6737 5.50071 8.6191 5.57528 8.53054L9.23478 4.1702C9.30819 4.08249 9.34259 3.97215 9.33132 3.85925C9.31976 3.74636 9.26455 3.64451 9.17496 3.57236L8.50502 3.03365C8.32034 2.88539 8.04693 2.91142 7.89491 3.09221L5.07846 6.44812L3.94668 5.49887C3.76517 5.34722 3.49119 5.36731 3.33541 5.54499L2.77125 6.18952Z"
    fill="white"
  />
</template>
